import React from 'react';

import { jFileLittle } from 'jamespot-user-api';
import { EditorUploader } from 'components/Editors/components/EditorUploader';
import { useIntl } from 'react-intl';
import { DATASOURCE_TYPE } from '../../const';
import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetExcelDatasourceContext } from '../../JRCWidgetExcelDatasourceTableEditor';

export const ExcelEditorUploader = ({
    token,
    onCreateSuccess,
}: {
    token: string;
    onCreateSuccess: (uri: string) => void;
}) => {
    const intl = useIntl();

    const { handlers } = useEditorContext<WidgetExcelDatasourceContext>();

    const onUploadSuccess = (fileResponse: jFileLittle) => {
        handlers.handleStart();
        handlers.jamespot.datasource
            .create({
                title: fileResponse.title,
                datasourceIdentifier: '',
                datasourceType: DATASOURCE_TYPE.CALC,
                token,
            })
            .then((response) => {
                onCreateSuccess(response.result.uri);
            })
            .catch(handlers.handleCatch)
            .finally(handlers.handleFinally);
    };

    return (
        <>
            {intl.formatMessage({ id: 'WIDGET_Datasource_Excel_Upload_Help' })}
            <EditorUploader
                token={token}
                uniqid={'name'}
                name={'attachment'}
                accept={
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.ms-excel'
                }
                label={intl.formatMessage({ id: 'WIDGET_Datasource_Use_Excel' })}
                multiple={false}
                network={handlers.jamespot.network}
                onUploadStart={handlers.handleStart}
                onUploadSuccess={onUploadSuccess}
            />
        </>
    );
};
